import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QueryBuilderValueBox } from "components/queries/queryBuilder/common/QueryBuilderValueBox";
import { QueryField, QueryInfo } from "system/query/QueryInfo";
import { QueryBuilderInnerLabel } from "../../common/QueryBuilderInnerLabel";

export interface RangeValueViewerProps {
  lowerValue: string | number | boolean | null | undefined;
  upperValue: string | number | boolean | null | undefined;

  queryInfo: QueryInfo;
  field: QueryField;
  borderColor: string;
  borderColorTop?: string;

  isViewerMode?: boolean;
}

export default function RangeValueViewer(props: RangeValueViewerProps): JSX.Element {
  const {i18n} = useTranslation();

  // If we don't have either a lower or upper value,
  // we don't have a range to display.
  if (props.lowerValue === undefined || props.upperValue === undefined) {
    return (<></>);
  }
  return (
    <>
      <QueryBuilderValueBox
        queryInfo={props.queryInfo}
        selectedField={props.field}
        borderColor={props.borderColor}
        isViewerMode={props.isViewerMode}
        inline={true}
        hideTime={props.field?.type === "timestamp" && (props.lowerValue as string ?? "").includes("T23:59:59")}
        value={props.lowerValue} />
      <Tooltip title={props.field?.type === "timestamp" ? i18n.t("query-form.range-to-tooltip") : i18n.t("query-form.range-through-tooltip")}>
        <Box sx={{display:"inline"}}>
          <QueryBuilderInnerLabel>
            {props.field?.type === "timestamp" ? i18n.t("to") : i18n.t("through")}
          </QueryBuilderInnerLabel>
        </Box>
      </Tooltip>
      <QueryBuilderValueBox
        queryInfo={props.queryInfo}
        selectedField={props.field}
        borderColor={props.borderColor}
        borderColorTop={props.borderColorTop}
        isViewerMode={props.isViewerMode}
        inline={true}
        hideTime={props.field?.type === "timestamp" && (props.upperValue as string ?? "").includes("T23:59:59")}
        value={props.upperValue} />
    </>
  );
}